<template>
  <div id="app">
      <Header></Header>
      <div class="flex">
      <MainNav />
      <!-- Navbar -->
      <div class="w-full">
        <div class="flex flex-col lg:flex-row items-center">
          <transition name="fade-fast" mode="out-in">
            <router-view 
              class="w-full px-2 md:px-8 max-w-2xl m-auto">
            </router-view>
          </transition>
          <!-- <div class="md:pt-10 mt-20 w-2/6 max-w-xs mr-auto">
            <h4>Did you know you can make money from reserveadesk.com?</h4>
          </div> -->
        </div>
      </div>
    </div>

    <vue-internet-checker
      @status="status"
      @event="event"
    />

      <!-- Footer code -->
      <!-- <appFooter></appFooter> -->
  </div>
</template>

<script>

import Header from '@/components/headerNav.vue'
import MainNav from '@/components/mainNav'
import { reduce, isEqual } from "lodash"
import vueInternetChecker from 'vue-internet-checker';


export default {
  name: 'app',
  components: {
    Header,
    MainNav,
    vueInternetChecker
  },
  data () {
    return {
      offlineToast: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    resourceDirectory () {
      return this.$store.state.resources.boundDirectory
    },
    groupDirectory () {
      return this.$store.state.groups.boundDirectory
    }
  },
  watch: {
    groupDirectory (newDoc, oldDoc) {

      console.log("group directory update: ", newDoc)
      console.log("oldDoc was:", oldDoc)

      if(!newDoc) return // doc was UNbound - clear docs should already be called

      if(oldDoc) {
        // we have an old doc AND newdoc, so we should compare

        // check the sizes, that'll tell us if it's an addition or deletion
        if(Object.keys(oldDoc).length <= Object.keys(newDoc).length){
          console.log("Doc was added OR updated")
          // Get that doc's id
          let diff = reduce(newDoc, function(result, value, key) {
              return isEqual(value, oldDoc[key]) ?
                  result : result.concat(key);
          }, []);
          console.log('docs added or updated:', diff);
          diff.forEach(element => {
            this.$store.dispatch("updateDoc", {
              data: newDoc[element],
              action: "update",
              docType: "groups",
            });
          });
        } else {
          // doc was removed
          // nothing in new doc that wasn't in old doc
          // doc was removed
          let docRemoved = reduce(oldDoc, function(result, value, key) {
              return isEqual(value, newDoc[key]) ?
                  result : result.concat(key);
          }, []);
          console.log("doc was removed:", docRemoved)
          this.$store.dispatch("updateDoc", {
            data: oldDoc[docRemoved],
            action: "delete",
            docType: "groups",
          });
        }

        return
      } 

      // if there's a new doc, and NOT an old one, means we need to put all docs into the store cos it's likely our first load
      for(let key in newDoc){
        this.$store.dispatch("updateDoc", {
          data: newDoc[key],
          action: "add",
          docType: "groups",
        });
      }

    },
    resourceDirectory (newDoc, oldDoc) {
      console.log("Resource directory update: ", newDoc)

      if(!newDoc) return // doc was UNbound - clear docs should already be called
      
      if(oldDoc) {
        // we have an old doc AND newdoc, so we should compare
        console.log('oldDoc docs count:', Object.keys(oldDoc).length);
        console.log('newDoc doccs count:', Object.keys(newDoc).length)
        
        // check the sizes, that'll tell us if it's an addition or deletion
        if(Object.keys(oldDoc).length <= Object.keys(newDoc).length){
          console.log("Doc was added OR updated")
          // Get that doc's id
          let diff = reduce(newDoc, function(result, value, key) {
              return isEqual(value, oldDoc[key]) ?
                  result : result.concat(key);
          }, []);
          console.log('docs added or updated:', diff);
          diff.forEach(element => {
            console.log('element:', element);
            
            this.$store.dispatch("updateDoc", {
              data: newDoc[element],
              action: "update",
              docType: "resources",
              fullDoc: false
            });
          });
        } else {
          // doc was removed
          // nothing in new doc that wasn't in old doc
          // doc was removed
          let docRemoved = reduce(oldDoc, function(result, value, key) {
              return isEqual(value, newDoc[key]) ?
                  result : result.concat(key);
          }, []);
          console.log("doc was removed:", docRemoved)
          this.$store.dispatch("updateDoc", {
            data: oldDoc[docRemoved],
            action: "delete",
            docType: "resources",
            fullDoc: false
          });
        }

        return
      } 
      
      // if there's a new doc, and NOT an old one, means we need to put all docs into the store cos it's likely our first load
      for(let key in newDoc){
        this.$store.dispatch("updateDoc", {
          data: newDoc[key],
          action: "add",
          docType: "resources",
          fullDoc: true
        });
      }
      
    },
    // user(newDoc, oldDoc) {
    //   console.log('this.user now:', this.user);
    //   console.log("old doc was:", oldDoc)
    // }
  },
  mounted () {
    console.log('app mounted')
    // console.log(this.$route.params.org)
    window.vm.mainApp = this

    console.log('user:', this.user);

    if(this.user) {
      document.body.setAttribute("data-theme", this.user.adminConfig.theme);
    }

  }, 
  methods: {
    status(ele) {
      console.log("status change?:",ele);
      this.onLine = ele;
      if(ele){
        this.$toast.dismiss(this.offlineToast);
        this.$toast.success(this.$t('gen-Back-Online'))
      } else {
        this.offlineToast = this.$toast.info(this.$t('gen-Offline'), {timeout: null});
        console.log('this.offlineToast:', this.offlineToast);
        
      }
    },
    event(ele) {
      console.log("internet connectivity event:",ele);
      // if(event.type==='offline'){
      //   this.$toast.warn("Offline!");
      //   alert("OFFLINE")
      // }
      // if(event.type==='online'){
      //   alert("ONLINE")
      // }
    },
  }
}
</script>


<style>

</style>
